import { useState } from "react";

export default function RetirementNumber() {
  const [spending, setSpending] = useState(60000);
  const annual = Number(spending) || 0;
  const nestEgg = annual * 25;

  return (
    <main style={{ padding: "120px 0 80px" }}>
      <div className="container">
        <h1 style={{ fontFamily: "Fraunces, serif", fontSize: 40, marginBottom: 8 }}>Retirement Number</h1>
        <p style={{ color: "var(--t2)", marginBottom: 20 }}>Use the 4% rule to estimate the retirement nest egg needed for your spending goal.</p>

        <div className="card-base" style={{ padding: 18, marginBottom: 18 }}>
          <label>
            <div className="font-mono" style={{ fontSize: 11, color: "var(--t3)", marginBottom: 6 }}>Desired annual retirement spending</div>
            <input className="input" type="number" value={spending} onChange={(e) => setSpending(e.target.value)} placeholder="e.g. 60000" />
          </label>
        </div>

        <div className="card-base" style={{ padding: 18 }}>
          <div className="font-mono" style={{ fontSize: 11, color: "var(--t3)", marginBottom: 8 }}>Target nest egg</div>
          <div style={{ fontFamily: "Fraunces, serif", fontSize: 28 }}>${nestEgg.toFixed(0)}</div>
        </div>
      </div>
    </main>
  );
}
